import { render, staticRenderFns } from "./ownMembercardStatistics.vue?vue&type=template&id=c3bd7e36&scoped=true"
import script from "./ownMembercardStatistics.vue?vue&type=script&lang=js"
export * from "./ownMembercardStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bd7e36",
  null
  
)

export default component.exports